const genericError = "There was a problem submitting your payment"

export default function SubscriptionHelper(subscriptionsPath) {
  async function subscribe(planId, productId, onSuccess, onError) {
    let subscription, error

    try {
      // eslint-disable-next-line prettier/prettier
      ({ subscription, error } = await createSubscription(planId, productId))
    } catch (unexpectedError) {
      error = genericError
    }

    if (
      subscription?.status === "active" ||
      subscription?.status === "trialing"
    ) {
      onSuccess(subscription)
    } else if (error) {
      onError(error)
    }
  }

  async function createSubscription(planId, productId) {
    const request = await fetch(subscriptionsPath, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": window.App.authenticityToken,
      },
      body: JSON.stringify({
        plan_id: planId,
        product_id: productId,
        price: { price_type: "monthly" },
      }),
      redirect: "error",
    })

    const result = await request.json()
    return subscriptionHandler(result)
  }

  async function subscriptionHandler({ error, errors, subscription }) {
    let subscriptionError = error || (errors && errors[0].data)

    return { error: subscriptionError, subscription }
  }

  return { subscribe }
}
